import { Blurred, Grid } from 'shared/components/Base/Base'
import { Text } from 'shared/components/Text/Text'
import { cyanD1, darkGray, midGray, primaryBlack } from 'shared/theme/colors'

import { Box } from '../../../components/Box/Box'
import { ReadMore } from '../../../components/ReadMore/ReadMore'
import { getDateTimeWindow, getStopLocation } from '../../../helpers/formatters'
import { LoadStop, LoadStopTypeDetail } from '../../../models/load'

interface MultistopPathItemProps {
  stop: LoadStop
  maskData?: boolean
  isSmall?: boolean
  isMedium?: boolean
}

export function MultistopPathItem({ stop, maskData, isSmall, isMedium }: MultistopPathItemProps) {
  const isPickup = stop.typeDetail === LoadStopTypeDetail.PICKUP
  const loadAddress =
    stop.locationAddress1 && stop.locationAddress2
      ? `${stop.locationAddress1}, ${stop.locationAddress2}`
      : `${stop.locationAddress1}`

  const loadLocation = getStopLocation(stop.locationCity, stop.locationState)
  const dateTimeFormatted =
    stop.dateStart && stop.dateEnd
      ? getDateTimeWindow(stop.dateStart, stop.dateEnd, stop.locationTimezone, {
          alwaysShowTime: true,
          addBullet: true,
        })
      : 'Appointment time not provided'

  return (
    <div className="multistop-path-item">
      <Grid columns={isSmall ? '1fr' : '1fr 1fr'} xsColumns="1fr">
        <div>
          {!isSmall && (
            <Text variant="uppercaseLabel2" color={isPickup ? midGray : cyanD1} mb={1}>
              {isSmall ? null : isPickup ? LoadStopTypeDetail.PICKUP : LoadStopTypeDetail.DELIVERY}
              {isSmall ? null : stop.loadingType && <> - {stop.loadingType}</>}
            </Text>
          )}

          <Grid
            className="multistop-path-item-location"
            alignItems="flex-start"
            gap="10px"
            xsGap="5px"
            columns="auto 1fr"
            xsColumns="1fr"
            mb={isSmall ? 0 : 1}
          >
            <Text
              variant={isMedium ? 'header6' : 'header3'}
              fontColor={primaryBlack}
              styles="text-transform: capitalize;"
            >
              {loadLocation}
            </Text>
            {isSmall && (
              <Blurred enabled={maskData}>
                <Text variant={isMedium ? 'label2' : 'label3'} fontColor={darkGray} mt={0.3}>
                  {dateTimeFormatted}
                </Text>
              </Blurred>
            )}
          </Grid>

          {maskData || isSmall ? null : (
            <Text variant="paragraph2" fontColor={midGray} mt={-0.3}>
              {loadAddress}
            </Text>
          )}
        </div>

        {!isSmall && (
          <Blurred enabled={maskData}>
            <Box mt={0} xsMt={1} />
            <Text variant="label2" fontColor={darkGray}>
              {dateTimeFormatted}
            </Text>
          </Blurred>
        )}
      </Grid>

      {isSmall || !stop.notes ? null : (
        <ReadMore lines={2}>
          <Text variant="paragraph1" fontColor={midGray} mt={2}>
            <strong>Facility notes: </strong>
            {stop.notes}
          </Text>
        </ReadMore>
      )}
    </div>
  )
}
